"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordsUpdate = exports.recordsUniqueUrlExtensionReset = exports.recordsUniqueUrlExtension = exports.recordsUniqueReferenceNoReset = exports.recordsUniqueReferenceNo = exports.recordsSuccess = exports.recordsSoftDelete = exports.recordsRestore = exports.recordsResetNotifyUnlockStatus = exports.recordsReset = exports.recordsRead = exports.recordsNotifyUnlockStatus = exports.recordsListDelete = exports.recordsList = exports.recordsHardDelete = exports.recordsFetchMagicLinkSiteExport = exports.recordsFetchMagicLinkSite = exports.recordsFetchMagicLinkReport = exports.recordsFetchMagicLinkPasscode = exports.recordsExistsReset = exports.recordsExists = exports.recordsError = exports.recordsCreate = exports.recordsCopySiteUrl = exports.recordsCopyReportUrl = exports.bulkReportFundDetailList = void 0;
var _records = require("./records.constant");
// @flow

// common success
var recordsSuccess = function recordsSuccess(actionType, data) {
  return {
    type: _records.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.recordsSuccess = recordsSuccess;
var recordsError = function recordsError(actionType, error) {
  return {
    type: _records.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * records read
 * @param payload
 * @returns api response
 * @description this function used to fetch record.
 */
exports.recordsError = recordsError;
var recordsRead = function recordsRead(data) {
  return {
    type: _records.actionTypes.READ,
    payload: data
  };
};

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
exports.recordsRead = recordsRead;
var recordsFetchMagicLinkSite = function recordsFetchMagicLinkSite(data) {
  return {
    type: _records.actionTypes.FETCH_MAGIC_LINK_SITE,
    payload: data
  };
};

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
exports.recordsFetchMagicLinkSite = recordsFetchMagicLinkSite;
var recordsFetchMagicLinkReport = function recordsFetchMagicLinkReport(data) {
  return {
    type: _records.actionTypes.FETCH_MAGIC_LINK_REPORT,
    payload: data
  };
};

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
exports.recordsFetchMagicLinkReport = recordsFetchMagicLinkReport;
var recordsFetchMagicLinkPasscode = function recordsFetchMagicLinkPasscode(data) {
  return {
    type: _records.actionTypes.FETCH_MAGIC_LINK_PASSCODE,
    payload: data
  };
};

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
exports.recordsFetchMagicLinkPasscode = recordsFetchMagicLinkPasscode;
var recordsFetchMagicLinkSiteExport = function recordsFetchMagicLinkSiteExport(data) {
  return {
    type: _records.actionTypes.FETCH_MAGIC_LINK_SITE_EXPORT,
    payload: data
  };
};

/**
 * records update
 * @param payload
 * @returns api response
 * @description this function used to update record.
 */
exports.recordsFetchMagicLinkSiteExport = recordsFetchMagicLinkSiteExport;
var recordsUpdate = function recordsUpdate(data) {
  return {
    type: _records.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * records create
 * @param payload
 * @returns api response
 * @description this function used to create record.
 */
exports.recordsUpdate = recordsUpdate;
var recordsCreate = function recordsCreate(data) {
  return {
    type: _records.actionTypes.CREATE,
    payload: data
  };
};

/**
 * records create
 * @param payload
 * @returns api response
 * @description this function used to notifyUnlockStatus record.
 */
exports.recordsCreate = recordsCreate;
var recordsNotifyUnlockStatus = function recordsNotifyUnlockStatus(data) {
  return {
    type: _records.actionTypes.NOTIFY_UNLOCK_STATUS,
    payload: data
  };
};

/**
 * records create
 * @param payload
 * @returns api response
 * @description this function used to notifyUnlockStatus record.
 */
exports.recordsNotifyUnlockStatus = recordsNotifyUnlockStatus;
var recordsResetNotifyUnlockStatus = function recordsResetNotifyUnlockStatus(data) {
  return {
    type: _records.actionTypes.RESET_NOTIFY_UNLOCK_STATUS,
    payload: data
  };
};

/**
 * records hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete record.
 */
exports.recordsResetNotifyUnlockStatus = recordsResetNotifyUnlockStatus;
var recordsHardDelete = function recordsHardDelete(data) {
  return {
    type: _records.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * records soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete record.
 */
exports.recordsHardDelete = recordsHardDelete;
var recordsSoftDelete = function recordsSoftDelete(data) {
  return {
    type: _records.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * records restore
 * @param payload
 * @returns api response
 * @description this function used to restore record.
 */
exports.recordsSoftDelete = recordsSoftDelete;
var recordsRestore = function recordsRestore(data) {
  return {
    type: _records.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * records list
 * @param payload
 * @returns api response
 * @description this function used to get list of record.
 */
exports.recordsRestore = recordsRestore;
var recordsList = function recordsList(data) {
  return {
    type: _records.actionTypes.LIST,
    payload: data
  };
};

/**
 * records list delete
 * @param payload
 * @returns api response
 * @description this function used to get deleted list of record.
 */
exports.recordsList = recordsList;
var recordsListDelete = function recordsListDelete(data) {
  return {
    type: _records.actionTypes.LIST_DELETE,
    payload: data
  };
};

/**
 * copy url
 * @param payload
 * @returns api response
 * @description this function used to copy url of record.
 */
exports.recordsListDelete = recordsListDelete;
var recordsCopySiteUrl = function recordsCopySiteUrl(data) {
  return {
    type: _records.actionTypes.COPY_SITE_URL,
    payload: data
  };
};

/**
 * copy url
 * @param payload
 * @returns api response
 * @description this function used to copy url of record.
 */
exports.recordsCopySiteUrl = recordsCopySiteUrl;
var recordsCopyReportUrl = function recordsCopyReportUrl(data) {
  return {
    type: _records.actionTypes.COPY_REPORT_URL,
    payload: data
  };
};

/**
 * records unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of record.
 */
exports.recordsCopyReportUrl = recordsCopyReportUrl;
var recordsUniqueReferenceNo = function recordsUniqueReferenceNo(data) {
  return {
    type: _records.actionTypes.UNIQUE_REFERENCE_NO,
    payload: data
  };
};

/**
 * records unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of record.
 */
exports.recordsUniqueReferenceNo = recordsUniqueReferenceNo;
var recordsUniqueReferenceNoReset = function recordsUniqueReferenceNoReset() {
  return {
    type: _records.actionTypes.UNIQUE_REFERENCE_NO_RESET
  };
};

/**
 * records unique url extension
 * @param payload
 * @returns api response
 * @description this function used to get unique url extension of record.
 */
exports.recordsUniqueReferenceNoReset = recordsUniqueReferenceNoReset;
var recordsUniqueUrlExtension = function recordsUniqueUrlExtension(data) {
  return {
    type: _records.actionTypes.UNIQUE_URL_EXTENSION,
    payload: data
  };
};

/**
 * records unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of record.
 */
exports.recordsUniqueUrlExtension = recordsUniqueUrlExtension;
var recordsUniqueUrlExtensionReset = function recordsUniqueUrlExtensionReset() {
  return {
    type: _records.actionTypes.UNIQUE_URL_EXTENSION_RESET
  };
};

/**
 * records exists or not
 * @param payload
 * @returns api response
 * @description this function used to check record exists or not
 */
exports.recordsUniqueUrlExtensionReset = recordsUniqueUrlExtensionReset;
var recordsExists = function recordsExists(data) {
  return {
    type: _records.actionTypes.RECORD_EXISTS,
    payload: data
  };
};

/**
 * fund detail
 * @param payload
 * @returns api response
 * @description this function used to get fund details.
 */
exports.recordsExists = recordsExists;
var bulkReportFundDetailList = function bulkReportFundDetailList(payload) {
  return {
    type: _records.actionTypes.FUND_DETAIL_LIST,
    payload: payload
  };
};

/**
 * records exists or not
 * @param payload
 * @returns api response
 * @description this function used to check record exists or not
 */
exports.bulkReportFundDetailList = bulkReportFundDetailList;
var recordsExistsReset = function recordsExistsReset() {
  return {
    type: _records.actionTypes.RECORD_EXISTS_RESET
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.recordsExistsReset = recordsExistsReset;
var recordsReset = function recordsReset(data) {
  return {
    type: _records.actionTypes.RESET,
    payload: data
  };
};
exports.recordsReset = recordsReset;